import React from 'react';
import styles from './ProgressBar.module.scss';
import { ProgressBarProps } from './types/propsType';

const ProgressBar: React.FC<ProgressBarProps> = ({ percentage, header, footer }) => {
   return (
     <div className={styles.progressBarContainer}>
        <div className={styles.header}>
         {header}
         <span className={styles.percentage}>{percentage}%</span>
       </div>
       <div className={styles.progressBar}>
         <div
           className={styles.progress}
           style={{ width: `${percentage}%` }}
         ></div>
       </div>
       
       <div className={styles.footer}>{footer}</div>
     </div>
   );
 };

export default ProgressBar;
